import { render, staticRenderFns } from "./role-create-dialog.vue?vue&type=template&id=21c90b8d"
import script from "./role-create-dialog.vue?vue&type=script&lang=js"
export * from "./role-create-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports